// Platform-aware path utilities
// Converts /alumni/* paths to root paths for TLA platform

const PLATFORM = process.env.REACT_APP_PLATFORM || 'nacme';
export const IS_TLA = PLATFORM === 'tla';

/**
 * Returns the correct path based on platform
 * TLA: /alumni/dashboard -> /dashboard
 * NACME: /alumni/dashboard -> /alumni/dashboard
 */
export const getAlumniPath = (path) => {
  if (IS_TLA && path.startsWith('/alumni')) {
    return path.replace('/alumni', '') || '/';
  }
  return path;
};

// Common path constants
export const PATHS = {
  login: IS_TLA ? '/login' : '/alumni/login',
  register: IS_TLA ? '/register' : '/alumni/register',
  dashboard: IS_TLA ? '/dashboard' : '/alumni/dashboard',
  forgotPassword: IS_TLA ? '/forgot-password' : '/alumni/forgot-password',
  resetPassword: IS_TLA ? '/reset-password' : '/alumni/reset-password',
  userAgreement: IS_TLA ? '/user-agreement' : '/alumni/user-agreement',
  smsTerms: IS_TLA ? '/sms-terms' : '/alumni/sms-terms',
  jobBoard: IS_TLA ? '/job-board' : '/alumni/job-board',
  directory: IS_TLA ? '/directory' : '/alumni/directory',
  messages: IS_TLA ? '/messages' : '/alumni/messages',
  groups: IS_TLA ? '/groups' : '/alumni/groups',
  profileManagement: IS_TLA ? '/profile-management' : '/alumni/profile-management',
  resumeReview: IS_TLA ? '/resume-review' : '/alumni/resume-review',
  verifyEmail: IS_TLA ? '/verify-email' : '/alumni/verify-email',
  newsCuration: IS_TLA ? '/news-curation' : '/alumni/news-curation',
};
